<template>
  <div class="position-relative">
    <task-list-container-header
      :title="title"
      :hide-title="hideTitle"
      :variant="variant"
      :icon="icon"
      :icon-color-class="iconColorClass"
      :hide-new-task-button="hideNewTaskButton"
      @createNewTask="createNewTask"
    ></task-list-container-header>
    <div
      v-if="loaded && !hasTasks"
      class="task-container-empty-icon"
    >
      <i :class="`fa fa-fw ${icon}`"></i>
    </div>
    <div v-if="hasTasks">
      <div
        v-if="groupByDay"
      >
        <section
          v-for="(day, date) in days"
          :key="date"
          class="tasklist mb-4"
        >
          <task-list-header
            :date="date"
          ></task-list-header>
          <task-list
            :tasks="day"
            :variant="variant"
            :readonly="readonly"
          ></task-list>
        </section>
      </div>
      <div
        v-else
      >
        <task-list
          :tasks="tasks"
          :variant="variant"
          :readonly="readonly"
        >
        </task-list>
        <div
          v-if="hasMoreTasks"
          class="pt-3"
        >
          <button
            class="btn btn-sm btn-secondary"
            @click.prevent="loadMoreTasks()"
          >
            Load More Tasks
          </button>
        </div>
      </div>
    </div>
    <a
      v-if="upcomingTaskCount > 0 && !usingRouter"
      :href="showTasks"
      class="d-block alert text-decoration-none mt-5 mb-0 small"
    >
      <i class="fa fa-fw fa-calendar text-flat-alizarin mr-1"></i>
      You have
      <span class="text-underline text-flat-peter-river">
        {{ upcomingTaskCount > 200 ? '200+' : upcomingTaskCount }} upcoming {{ upcomingTaskCount === 1 ? 'task' : 'tasks' }}</span>.
    </a>
    <router-link
      v-if="upcomingTaskCount > 0 && usingRouter"
      :to="{name: 'tasks.upcoming', params: { userId }}"
      class="d-block alert text-decoration-none mt-5 mb-0 small"
    >
      <i class="fa fa-fw fa-calendar text-flat-alizarin mr-1"></i>
      You have
      <span class="text-underline text-flat-peter-river">
        {{ upcomingTaskCount > 200 ? '200+' : upcomingTaskCount }} upcoming {{ upcomingTaskCount === 1 ? 'task' : 'tasks' }}</span>.
    </router-link>
  </div>
</template>

<script>
import moment from 'moment'
import TaskListContainerHeader from '@/components/TaskListContainerHeader'
import TaskListContainer from '@/components/TaskListContainer'
import TaskListHeader from '@/components/TaskListHeader'
import TaskList from '@/components/TaskList'
import urls from '@/api/urls'

export default {
  components: {
    TaskListContainerHeader,
    TaskListHeader,
    TaskList
  },
  extends: TaskListContainer,
  props: {
    title: {
      type: String,
      default: ''
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'fa-check'
    },
    iconColorClass: {
      type: String,
      default: ''
    },
    usingRouter: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    todayLabel () {
      return moment().format('MMM D')
    },
    newTasksDueAt () {
      return moment().format('YYYY-MM-DD')
    },
    showTasks () {
      return urls.businessPlan.showTasks('upcoming', this.userId)
    }
  },
  beforeRouteEnter (from, to, next) {
    next(vm => vm.loadMoreTasks(1))
  }
}
</script>

